import Vue from "vue";
import * as Api from "../../api";
import Utils from "../../untils";

const state = {}

const getters = {}

const mutations = {}

const actions = {
  getConciergeEnquiries({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/retrieve/concierge/enquiries/${params.page}/${params.size}`,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getConciergeEnquiriesCallback");
      }
    });
  },
  getReferredClients({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/retrieve/referred/clients/${params.page}/${params.size}`,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getReferredClientsCallback");
      }
    });
  },
  getConciergeReferrals({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/retrieve/concierge/referrals/${params.page}/${params.size}`,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getConciergeReferralsCallback");
      }
    });
  },
  getLookingForProperties({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/retrieve/looking/property/${params.page}/${params.size}`,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getLookingForPropertiesCallback");
      }
    });
  },
  createAgentNoteRecord({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/create/note`,
      ...params
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "createAgentNoteRecordCallback");
      }
    });
  },
  createBuyerRegistrationAgentNoteRecord({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/create/buyer/reg/note`,
      ...params
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "createBuyerRegistrationAgentNoteRecordCallback");
      }
    });
  },
  createConciergeReferralAgentNoteRecord({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/create/concierge/referral/note`,
      ...params
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "createConciergeReferralAgentNoteRecordCallback");
      }
    });
  },
  getAgentNotes({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/retrieve/notes/${params.contactId}`,
      ...params
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getAgentNotesCallback");
      }
    });
  },
  getBuyerRegistrationAgentNotes({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/retrieve/buyer/reg/notes/${params.contactId}`,
      ...params
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getBuyerRegistrationAgentNotesCallback");
      }
    });
  },
  getConciergeReferralAgentNotes({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/retrieve/concierge/referral/notes/${params.contactId}`,
      ...params
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getConciergeReferralAgentNotesCallback");
      }
    });
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/enquiry.js